export type AriaSort = 'ascending' | 'descending' | 'none';

/** `aria-sort` value of a sortable column header. */
export const ariaSort = (active: boolean, descending: boolean): AriaSort => {
  if (!active) return 'none';
  return descending ? 'descending' : 'ascending';
};
